import { resolveShopStyle } from "@/utils/shopStyle";
import { useRuntimeConfig } from "#imports";
import { withAustraliaDevelopmentLowcode } from "@/utils/australiaDevelopmentLowcode";
import { templateRegistry } from "../index";
import { mergeTemplate } from "./mergeTemplate";
import { TEMPLATE_KEYS } from "./templateTypes";

const TEMPLATE_STYLE_MAP = {
  japan: TEMPLATE_KEYS.JAPAN,
  jp: TEMPLATE_KEYS.JAPAN,
  japanese: TEMPLATE_KEYS.JAPAN,
  japanstyle: TEMPLATE_KEYS.JAPAN,
  "japan-style": TEMPLATE_KEYS.JAPAN,
  "日本": TEMPLATE_KEYS.JAPAN,
  "日本风格": TEMPLATE_KEYS.JAPAN,
  "日本風格": TEMPLATE_KEYS.JAPAN,
  "日式": TEMPLATE_KEYS.JAPAN,
  "日系": TEMPLATE_KEYS.JAPAN,
  australia: TEMPLATE_KEYS.AUSTRALIA,
  au: TEMPLATE_KEYS.AUSTRALIA,
  australian: TEMPLATE_KEYS.AUSTRALIA,
  australiastyle: TEMPLATE_KEYS.AUSTRALIA,
  "australia-style": TEMPLATE_KEYS.AUSTRALIA,
  "澳洲": TEMPLATE_KEYS.AUSTRALIA,
  "澳洲风格": TEMPLATE_KEYS.AUSTRALIA,
  "澳洲風格": TEMPLATE_KEYS.AUSTRALIA,
};

export function resolveTemplateKeyByStyle(normalizedStyle = "") {
  return TEMPLATE_STYLE_MAP[normalizedStyle] || TEMPLATE_KEYS.DEFAULT;
}

export function getCurrentTemplate(templateKey = TEMPLATE_KEYS.DEFAULT) {
  const defaultTemplate = templateRegistry[TEMPLATE_KEYS.DEFAULT];
  const currentTemplate = templateRegistry[templateKey] || defaultTemplate;

  return mergeTemplate(defaultTemplate, currentTemplate);
}

export function resolveSiteTemplate(siteInfo = {}, storeInfo = {}) {
  const styleInfo = resolveShopStyle({
    ...siteInfo,
    ...storeInfo,
  });
  const templateKey = resolveTemplateKeyByStyle(styleInfo.normalized);
  let template = getCurrentTemplate(templateKey);
  if (process.env.NODE_ENV === "development") {
    let publicConfig = {};
    try {
      publicConfig = useRuntimeConfig().public;
    } catch {
      // Template resolution can also run after an asynchronous API callback.
      if (typeof window !== "undefined") publicConfig = window.__NUXT__?.config?.public || {};
    }
    template = withAustraliaDevelopmentLowcode(template, {
      isDevelopment: true,
      apiEnvironment: publicConfig.apiEnvironment,
      variant: publicConfig.devAustraliaLowcode,
    });
  }

  return {
    ...template,
    styleInfo,
    templateKey: template.key || templateKey,
    resolvePage(pageKey) {
      return this.pages?.[pageKey] || null;
    },
    resolveSection(sectionKey) {
      return this.sections?.[sectionKey] || null;
    },
  };
}

export default getCurrentTemplate;
